<script setup lang="ts">
import { onMounted } from 'vue';
import ProgressSpinner from 'primevue/progressspinner';

import AppHeader from '../components/AppHeader.vue';
import AppBreadcrumbs from '../components/AppBreadcrumbs.vue';

import { useOfflineData } from '../composables/useOfflineData';

const { fetchAllData, isLoading, isDone } = useOfflineData();

onMounted(() => {
  fetchAllData();
});
</script>

<template>
  <div class="flex min-h-screen flex-col justify-center bg-gray-50 font-lato text-gray-900">
    <ProgressSpinner v-if="isLoading" />

    <template v-else>
      <AppHeader />

      <main class="flex flex-1 flex-col px-8 pb-2 pt-6">
        <AppBreadcrumbs />

        <RouterView v-if="isDone" class="flex-1" />
      </main>
    </template>
  </div>
</template>
